import { render, staticRenderFns } from "./sureSend.vue?vue&type=template&id=5aada4e6&scoped=true&"
import script from "./sureSend.vue?vue&type=script&lang=js&"
export * from "./sureSend.vue?vue&type=script&lang=js&"
import style0 from "./sureSend.vue?vue&type=style&index=0&id=5aada4e6&prod&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5aada4e6",
  null
  
)

export default component.exports